import api from './api'

const documentService = {
  // Get documents for a file
  getDocuments: (fileId, params) => api.get(`/mrd/documents/${fileId}`, { params }),

  // Upload document
  uploadDocument: (fileId, formData) => {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return api.post(`/mrd/documents/upload/${fileId}`, formData, config)
  },

  // Download document
  downloadDocument: (id) => api.get(`/mrd/documents/download/${id}`, { 
    responseType: 'blob' 
  }),

  // Verify document
  verifyDocument: (id, data) => api.patch(`/mrd/documents/verify/${id}`, data),

  // Delete document
  deleteDocument: (id) => api.delete(`/mrd/documents/${id}`),

  // Update document
  updateDocument: (id, data) => api.put(`/mrd/documents/${id}`, data),

  // Get document by ID
  getDocumentById: (id) => api.get(`/mrd/documents/single/${id}`),

  // Bulk upload
  bulkUpload: (fileId, formData) => {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return api.post(`/mrd/documents/bulk-upload/${fileId}`, formData, config)
  }
}

export default documentService